import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import ForgotPassword from './components/ForgotPassword';
import Layout from './components/Layout';
// import Dashboard from './components/Dashboard';
import PendingApprovals from './components/PendingApprovals';
import ExpensesPendingApprovals from './components/expenses/ExpensesPendingApprovals';
import CreateManualLedger from './components/CreateManualLedger';
import EditManualLedger from './components/EditManualLedger';
import ManualLedgersList from './components/ManualLedgersList';

// import RevenuesDashboard from './components/revenues/RevenuesDashboard';
import CreateInvoice from './components/revenues/CreateRevenuesInvoice';
import ClientsList from './components/revenues/ClientsLedgers';
import CreateClient from './components/revenues/CreateClient';
import AllInvoices from './components/revenues/AllRevenueInvoices';
import EditInvoice from './components/revenues/EditRevenuesInvoice';

// import ExpensesDashboard from './components/expenses/ExpensesDashboard';
import CreateExpensesInvoice from './components/expenses/CreateExpensesInvoice';
import CompanyLedgers from './components/expenses/CompanyLedgers';
import CreateCompanyAccount from './components/expenses/CreateCompanyAccount';
import AllExpensesInvoices from './components/expenses/AllExpensesInvoices';
import EditExpensesInvoice from './components/expenses/EditExpensesInvoice';
import Reports from './components/reports/Reports';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import './index.css';
// testt

// Loading Component
const LoadingSpinner: React.FC = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

// Protected Route Componentt
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Layout>{children}</Layout>;
};

// Main App Component
const AppContent: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/register"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <RegistrationPage />}
        />
        <Route
          path="/forgot-password"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ForgotPassword />}
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* Revenues and Expenses Dashboard routes removed - using Gross Profit as default */}
        <Route
          path="/create-invoice"
          element={
            <ProtectedRoute>
              <CreateInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-expenses-invoice"
          element={
            <ProtectedRoute>
              <CreateExpensesInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-approvals"
          element={
            <ProtectedRoute>
              <PendingApprovals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-revenue-approvals"
          element={
            <ProtectedRoute>
              <PendingApprovals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-expense-approvals"
          element={
            <ProtectedRoute>
              <ExpensesPendingApprovals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-invoices"
          element={
            <ProtectedRoute>
              <AllInvoices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-expenses-invoices"
          element={
            <ProtectedRoute>
              <AllExpensesInvoices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-invoice/:invoiceId"
          element={
            <ProtectedRoute>
              <EditInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-expenses-invoice/:invoiceId"
          element={
            <ProtectedRoute>
              <EditExpensesInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <ClientsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/company-ledgers"
          element={
            <ProtectedRoute>
              <CompanyLedgers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-client"
          element={
            <ProtectedRoute>
              <CreateClient />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-company-account"
          element={
            <ProtectedRoute>
              <CreateCompanyAccount />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-ledger"
          element={
            <ProtectedRoute>
              <CreateManualLedger />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-manual-ledger/:id"
          element={
            <ProtectedRoute>
              <EditManualLedger />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manual-ledgers"
          element={
            <ProtectedRoute>
              <ManualLedgersList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-management"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gross-profit-report"
          element={<Navigate to="/dashboard" replace />}
        />
        <Route
          path="/invoices"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">All Invoices</h2>
                  <p className="text-gray-600">This feature is coming soon...</p>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;